var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"articles-table"}},[_c('datatable',{key:`ArticleTable${_vm.key}`,attrs:{"data":_vm.table,"loading":_vm.isBusy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }